import { TOTAL_USERS_WITH_MILLION_UNIT } from 'src/common/constants/user';
import type { Box } from 'src/features/home/components/two-boxes/two-boxes.types';
import ForStudents from 'src/images/pngs/home/for-students.png';
import ForTeam from 'src/images/pngs/home/for-team.png';

export const twoBoxes: Box[] = [
  {
    id: '1',
    header: 'TryHackMe Business',
    title: 'Cyber security training for your team',
    description: `Join hundreds of organisations and over ${TOTAL_USERS_WITH_MILLION_UNIT} users advancing their cyber security skills with TryHackMe.`,
    button: 'Learn More',
    image: ForTeam,
    imageHasWrapper: true,
    link: 'https://business.tryhackme.com',
  },
  {
    id: '2',
    header: 'TryHackMe Education',
    title: 'Cyber security training for your students',
    description:
      'Assign fun pre-built security labs and challenges to your students. Manage assignments in a teaching dashboard and monitor user progress.',
    button: 'Learn More',
    image: ForStudents,
    link: '/classrooms',
  },
];
